import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalWindowParameters} from '../../modal-window-parameters';
import {ModalWindowResponse} from '../../modal-window-response';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-modal-window-selection',
  templateUrl: './modal-window-selection.component.html',
  styleUrls: ['./modal-window-selection.component.scss']
})
export class ModalWindowSelectionComponent implements OnInit {

  @Input() modalWindowParameters: ModalWindowParameters;
  @Output() modalWindowResponse: EventEmitter<ModalWindowResponse> = new EventEmitter<ModalWindowResponse>();
  formGroup: FormGroup;

  constructor(
    protected formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      selection: this.modalWindowParameters.selectParameters.items[0][this.modalWindowParameters.selectParameters.keyField]
    });
  }
  onCancelClick() {
    this.modalWindowResponse.next({confirmed: false});
  }
  onApplyClick() {
    this.modalWindowResponse.next({confirmed: true, selectionResult: this.formGroup.controls.selection.value});
  }
}
